import tick from '@/modules/tick/tick';

/**
 * Interact Store
 * The interact store is used to control global interactions and
 * global modals for the entire application.
 *
 * Includes:
 * Toast Notification
 * Popmenu (slide up menu with multiple button choices and a cancel)
 * Modals - Profile
 */
export default {
  state: {
    popmenu: {
      title: null,
      buttons: [],
      show: false,
      cancelButton: 'Cancel',
      onCancel: null,
      description: null
    },
    toast: {
      title: null,
      icon: null,
      show: false,
      timeout: 2000
    },
    sidemenu: {
      show: false
    },
    modals: {
      profile: false,
      selectDriver: {
        show: false,
        title: 'Select Driver',
        callback: null,
        disable: []
      },
      newLeague: {
        show: false,
        title: 'Create a Private League',
        callback: null
      },
      joinLeague: {
        show: false,
        title: 'Join a League',
        callback: null
      },
      manageLeagues: {
        show: false,
        title: 'Join a League',
        callback: null
      }
    }
  },
  getters: {},
  mutations: {
    'modals/profile'(state: any, payload: any) {
      state.modals.profile = payload;
    },
    'modals/selectDriver'(state: any, payload: any) {
      state.modals.selectDriver = payload || {
        show: false,
        title: 'Select Driver',
        callback: null,
        budget: null
      };
    },
    'modals/newLeague'(state: any, payload: any) {
      state.modals.newLeague.show = payload;
    },
    'modals/joinLeague'(state: any, payload: any) {
      state.modals.joinLeague.show = payload;
    },
    'modals/manageLeagues'(state: any, payload: any) {
      state.modals.manageLeagues.show = payload;
    },
    popmenu(state: any, payload: any) {
      state.popmenu = payload;
    },
    toast(state: any, payload: any) {
      state.toast = payload;
    },
    sidemenu(state: any, payload: any) {
      state.sidemenu = payload;
    }
  },
  actions: {
    async 'interact/error'(context: any, message: string) {
      context.dispatch('interact/popmenu', {
        title: 'Error',
        description: `${message}`,
        cancelButton: 'Ok',
        onCancel: null
      });
    },
    'interact/email'(context: any, payload: any) {
      window.location.href = `mailto:${payload.email}?subject=${payload.subject}`;
    },
    'interact/modals/profile/toggle'(context: any) {
      context.commit('modals/profile', !context.state.modals.profile);
    },
    async 'interact/modals/selectDriver'(context: any, payload: any) {
      return new Promise((resolve, reject) => {
        let config = {
          title: payload.title,
          budget: payload.budget || null,
          disable: payload.disable || [],
          show: true,
          callback: (driver: any) => {
            resolve(driver);
          }
        };
        context.commit('modals/selectDriver', config);
      });
    },
    'interact/modals/newLeague'(context: any) {
      context.commit('modals/newLeague', !context.state.modals.newLeague.show);
    },
    'interact/modals/joinLeague'(context: any) {
      context.commit(
        'modals/joinLeague',
        !context.state.modals.joinLeague.show
      );
    },
    'interact/modals/manageLeagues'(context: any) {
      context.commit(
        'modals/manageLeagues',
        !context.state.modals.manageLeagues.show
      );
    },
    'interact/sidemenu/show'(context: any) {
      context.commit('sidemenu', {
        show: true
      });
    },
    'interact/sidemenu/hide'(context: any) {
      context.commit('sidemenu', {
        show: false
      });
    },
    'interact/sidemenu/toggle'(context: any) {
      context.commit('sidemenu', {
        show: !context.state.sidemenu.show
      });
    },
    'interact/popmenu'(context: any, payload: any) {
      if (payload) {
        context.commit('popmenu', {
          title: payload.title || 'Select',
          buttons: payload.buttons || [],
          show: true,
          description: payload.description || null,
          cancelButton: payload.cancelButton || 'Cancel',
          onCancel: payload.onCancel || null
        });
      } else {
        context.commit('popmenu', {
          title: null,
          buttons: [],
          show: false,
          description: null,
          cancelButton: 'Cancel',
          onCancel: null
        });
      }
    },
    'interact/popmenu/hide'(context: any) {
      context.commit('popmenu', {
        title: 'Select',
        buttons: [],
        show: false,
        description: null
      });
    },
    'interact/toast'(context: any, payload: any) {
      context.commit('toast', {
        title: payload.title || 'Select',
        icon: payload.icon || null,
        show: true,
        click: payload.click || null,
        timeout: payload.timeout || 2000
      });
    },
    'interact/toast/hide'(context: any) {
      context.commit('toast', {
        title: null,
        icon: null,
        show: false,
        click: null,
        timeout: null
      });
    }
  }
};
